import WrapperFilterSort from './WrapperFilterSort'

export default WrapperFilterSort
